// src/layout/authorized/admin/organization/page/organization-edit/organization-logo.js
import React from 'react'
import { useLoad } from '../../../../../../shared/hooks/load'
import { useApiBlobFilePublic, useApiFormFilePublic } from '../../../../../../api-new/state/storage'
import { UppyImageUpload } from '../../../../../../shared/image-upload/uppy-image-upload'
import { ORGANIZATION_LOGO_OUTPUT } from '../../../../../../shared/image-upload/image-upload-config'
import { Card } from '../../../../../../shared/card/card'

export const OrganizationLogo = ({ organizationID, disabled }) => {
  const apiFormFilePublic = useApiFormFilePublic()
  const apiBlobFilePublic = useApiBlobFilePublic()

  useLoad(async () => {
    await apiBlobFilePublic.get(`${organizationID}/organization`)
  }, [organizationID])

  const resolveTarget = async () => ({
    url: `${process.env.REACT_APP_API_STORAGE}/api/v1/file-public/${organizationID}/organization`,
    method: 'POST',
  })

  const handleUploaded = async () => {
    await apiBlobFilePublic.get(`${organizationID}/organization`)
  }

  const handleDelete = async () => {
    await apiFormFilePublic.delete(`${organizationID}/organization`)
    apiBlobFilePublic.init()
  }

  // Its own card: the logo saves on its own, never with the form's Update,
  // and its "last updated" is the stored file's (storage's Last-Modified),
  // apart from the organization record's above. Storage lets staff save
  // another organization's logo with SYS_ORGANIZATION update, the same
  // permission as the form's Update, so it is disabled without it.
  return (
    <Card title="Logo">
      <UppyImageUpload
        previewBlob={apiBlobFilePublic.blob}
        aspect={[13, 3]}
        output={ORGANIZATION_LOGO_OUTPUT}
        maxFileSize={500 * 1024}
        noun="logo"
        hint="Shown in the page header, 28 px high. Best at 520×120 or larger; a PNG keeps its transparency."
        disabled={disabled}
        updatedAt={apiBlobFilePublic.lastModified}
        resolveTarget={resolveTarget}
        onUploaded={handleUploaded}
        onDelete={handleDelete}
      />
    </Card>
  )
}
